import {
  IntegrationChannelType,
  IntegrationChannelViewFragment,
} from 'generated/graphql';

export const isCensusIntegration = (channel: IntegrationChannelViewFragment) =>
  channel.type === IntegrationChannelType.Webhook &&
  channel.displayName === 'Census';
